module.exports = __webpack_public_path__ + "assets/img/ozmo-facebook.59f38361.png";